import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppGroupIdBrazeDocsLookupCacheKeys } from "./constants";
import type {
  PostAppGroupIdBrazeDocsLookupErrors,
  PostAppGroupIdBrazeDocsLookupProps,
  PostAppGroupIdBrazeDocsLookupResult,
} from "./types";

export const postAppGroupIdBrazeDocsLookup = reactQueryMutationAdapter(
  postAppGroupIdBrazeDocsLookupCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostAppGroupIdBrazeDocsLookupErrors>()(
    (props: PostAppGroupIdBrazeDocsLookupProps): Promise<PostAppGroupIdBrazeDocsLookupResult> => {
      return fetch(
        `/${props.appGroupId}/braze_docs/lookup`,
        "POST",
        {
          url: props.url,
        },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
